<template>
  <div class="base-loading-state">
    <v-progress-linear
      indeterminate
      color="primary"
    />
    <p
      v-if="message"
      class="base-loading-state__message"
    >
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BaseLoadingState',
  props: {
    message: {
      type: String,
      required: false,
      default: 'Carregando informações...'
    }
  }
}
</script>

<style lang="scss">
.base-loading-state {
  &__message {
    margin: 8px 0 0;
    font-size: 0.8rem;
    color: var(--ds-color-black-055);
  }
}
</style>
